/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：622
 */

module.exports = {
  packageProgress: "PackageProgress_packageProgress__mH-0N",
  circle: "PackageProgress_circle__hZ-ze",
  percentText: "PackageProgress_percentText__19jRN",
  symbol: "PackageProgress_symbol__5UtGq",
  close: "PackageProgress_close__k1amu",
  progressType: "PackageProgress_progressType__2S_25",
  completePackage: "PackageProgress_completePackage__INrhO",
  secondIcon: "PackageProgress_secondIcon__Tp_0U"
}
